import { accessRole } from '../../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Input, Label
} from "reactstrap"
import DatePicker from '../../../../../helpers/ui/DatePicker'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import Select from '../../../../../helpers/ui/CustomSelect'
import { AvForm, AvGroup, AvField, AvInput, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"
import Shimmer from 'react-shimmer-effect'

import apiResponse from '../../../../../services/apiResponse'

import IndexBloc from '../Index/Blocs/IndexBloc'
import CreateBloc from '../Create/Blocs/CreateBloc'
import CustomSelect from '../../../../../helpers/ui/CustomSelect'

class IndexView extends Component {

    timer
    indexBloc = new IndexBloc();
    createBloc = new CreateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            criteriaListOption: null,
            componentListOption: null,
            optionType:[
                {label : 'Presensi', value: 1},
                {label : 'SKP', value: 2},
                {label : 'Ekspektasi Pimpinan', value: 3}
            ],
        }
    }

    submitData = async () => {
        const filteredData = Object.fromEntries(
            Object.entries(this.state.dataForm).filter(([_, value]) => value && value !== "" && value !== null)
          );
        await this.createBloc.fetchUpdate(filteredData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                ...values,
                special_allowance_uuid: this.props.uuid,
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.indexBloc.fetchDetail({ uuid: this.props.uuid })
        // this.createBloc.fetchCriteriaList()
        this.createBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ 
                        detail: result.data.response,
                        criteriaUUID: result.data.response.assessment_component_detail?.assessment_component_parent_detail?.assessment_component_uuid,
                     })
                    break
                default:
                    break
            }
            console.log(this.state.detail)
        })
        // this.createBloc.criteriaListChannel.subscribe((result) => {
        //     switch (result.status) {
        //         case apiResponse.COMPLETED:
        //             this.setState({
        //                 criteriaListOption: result.data?.response?.result?.filter((item)=> item.assessment_component_type === 1),
        //                 componentListOption: result.data?.response?.result?.filter((item)=> item.assessment_component_type === 2),
        //             });
        //             break
        //         case apiResponse.ERROR:
        //             break
        //         default:
        //             break
        //     }
        // })
    }

    componentWillUnmount() {
        this.indexBloc.detailChannel?.unsubscribe()
        this.createBloc.criteriaListChannel?.unsubscribe()
    }

    render() {
        const { detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/master/komponen_penilaian_bobot_tunjangan_khusus.html`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>Detail Bobot Tunjangan Khusus</CardTitle>
                            <hr />
                            <AvForm
                                className="needs-validation"
                                onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                            >
                            <Row className="mb-3">
                                <label className="col-md-3 col-form-label" >
                                    Jenis Penilaian <span className="text-danger">*</span>
                                </label>
                                <Col md={3}>
                                    <CustomSelect
                                        name="special_allowance_type"
                                        placeholder="Jenis Penilaian..."
                                        errorMessage="Jenis Penilaian"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                        onChange={(opt) => {
                                            this.setState({
                                                    slctype: opt.special_allowance_type,
                                                //  selectedComponent: null
                                            })
                                            alert(opt.value)
                                            console.log(opt)
                                        }}
                                        options={this.state.optionType}
                                        // optionLabel="assessment_component_name"
                                        // optionValue="assessment_component_uuid"
                                        // isLoading={!this.state.criteriaListOption?.length}
                                    />
                                </Col>
                            </Row>
                                {/* <Row className="mb-3">
                                    <label className="col-md-3 col-form-label" >
                                        Kriteria Penilaian <span className="text-danger">*</span>
                                    </label>
                                    <Col>
                                        {detail ?
                                            <Select
                                                name="special_allowance_parent_component_uuid"
                                                placeholder="Kriteria Penilaian..."
                                                errorMessage="Kriteria Penilaian"
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                onChange={(opt) => {
                                                    this.setState({
                                                        criteriaUUID: opt.assessment_component_uuid,
                                                        selectedComponent: null
                                                    })
                                                }}
                                                defaultValue={detail.assessment_component_detail?.assessment_component_parent_detail?.assessment_component_uuid}
                                                options={this.state.criteriaListOption}
                                                optionLabel="assessment_component_name"
                                                optionValue="assessment_component_uuid"
                                                isLoading={!this.state.criteriaListOption?.length}
                                            />
                                            :
                                            <Shimmer>
                                                <div style={{
                                                    width: "100%", height: "16px", alignSelf: "center", borderRadius: "8px",
                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5'
                                                }} />
                                            </Shimmer>
                                        }
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <label
                                        htmlFor="special_allowance_type"
                                        className="col-md-3 col-form-label"
                                    >
                                        Komponen Penilaian <span className="text-danger">*</span>
                                    </label>
                                    <Col>
                                        {detail ?
                                            <Select
                                                name="special_allowance_component_uuid"
                                                placeholder="Pilih Komponen Penilaian..."
                                                errorMessage="Pilih Komponen Penilaian"
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                defaultValue={detail.assessment_component_detail?.assessment_component_uuid}
                                                options={this.state.componentListOption?.filter((item) => item.assessment_component_parent_uuid === this.state.criteriaUUID)}
                                                optionLabel="assessment_component_name"
                                                optionValue="assessment_component_uuid"
                                                isLoading={!this.state.componentListOption?.length}
                                            />
                                            :
                                            <Shimmer>
                                                <div style={{
                                                    width: "100%", height: "16px", alignSelf: "center", borderRadius: "8px",
                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5'
                                                }} />
                                            </Shimmer>
                                        }
                                    </Col>
                                </Row> */}
                                <Row className="mb-3">
                                    <label className="col-md-3 col-form-label" >
                                        Nama Bobot <span className="text-danger">*</span>
                                    </label>
                                    <Col>
                                        {detail ?
                                            <AvField
                                                name="special_allowance_name"
                                                value={detail.special_allowance_name}
                                                disabled
                                                placeholder="Nama Bobot..."
                                                type="text"
                                                errorMessage="Masukkan Nama Bobot"
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                id="special_allowance_name"
                                            />
                                            :
                                            <Shimmer>
                                                <div style={{
                                                    width: "100%", height: "16px", alignSelf: "center", borderRadius: "8px",
                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5'
                                                }} />
                                            </Shimmer>
                                        }
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <label className="col-md-3 col-form-label" >
                                        Nilai Bobot <span className="text-danger">*</span>
                                    </label>
                                    <Col>
                                        {detail ?
                                            <AvField
                                                name="special_allowance_value"
                                                value={detail.special_allowance_value}
                                                placeholder="Nilai Bobot..."
                                                type="text"
                                                errorMessage="Masukkan Kriteria Penilaian"
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                id="special_allowance_value"
                                            />
                                            :
                                            <Shimmer>
                                                <div style={{
                                                    width: "100%", height: "16px", alignSelf: "center", borderRadius: "8px",
                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5'
                                                }} />
                                            </Shimmer>
                                        }
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <label className="col-md-3 col-form-label" >
                                        Berlaku Dari <span className="text-danger">*</span>
                                    </label>
                                    <Col>
                                        {detail ?
                                            <div className="customDatePickerWidth">
                                                <DatePicker
                                                    name="special_allowance_start_date"
                                                    id="special_allowance_start_date"
                                                    placeholder="Tanggal Mulai berlaku..."
                                                    errorMessage="Masukkan Tanggal Mulai berlaku"
                                                    isWeekday={true}
                                                    dateFormat="dd/MM/yyyy"
                                                    validate={{ required: { value: true } }}
                                                    defaultValue={detail.special_allowance_start_date}
                                                />
                                            </div>
                                            :
                                            <Shimmer>
                                                <div style={{
                                                    width: "100%", height: "16px", alignSelf: "center", borderRadius: "8px",
                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5'
                                                }} />
                                            </Shimmer>
                                        }
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <label className="col-md-3 col-form-label">
                                        Berlaku Sampai 
                                        {/* <span className="text-danger">*</span> */}
                                    </label>
                                    <Col>
                                        {detail ?
                                            <div className="customDatePickerWidth">
                                                <DatePicker
                                                    name="special_allowance_end_date"
                                                    id="special_allowance_end_date"
                                                    placeholder="Tanggal selesai berlaku..."
                                                    errorMessage="Masukkan Tanggal selesai berlaku"
                                                    isWeekday={true}
                                                    dateFormat="dd/MM/yyyy"
                                                    // validate={{ required: { value: true } }}
                                                    defaultValue={detail.special_allowance_end_date}
                                                />
                                            </div>
                                            :
                                            <Shimmer>
                                                <div style={{
                                                    width: "100%", height: "16px", alignSelf: "center", borderRadius: "8px",
                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5'
                                                }} />
                                            </Shimmer>
                                        }
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md="3"></Col>
                                    <Col md="9">
                                        <Link to="?">
                                            <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                        </Link>
                                        {' '}
                                        <Button color="success" type="submit">
                                            <i className="uil-arrow-up-right"></i> Simpan Data
                                        </Button>
                                    </Col>
                                </Row>
                            </AvForm>
                        </CardBody>
                    </Card>

                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.redirect ?
                    <Redirect to='/master/komponen_penilaian_bobot_tunjangan_khusus.html?' />
                    : null}
            </Fragment>
        )
    }

}

export default IndexView